__turbopack_context__.v({
  "closeButton": "SignInModal-module__pJtYKW__closeButton",
  "description": "SignInModal-module__pJtYKW__description",
  "emailButton": "SignInModal-module__pJtYKW__emailButton",
  "error": "SignInModal-module__pJtYKW__error",
  "form": "SignInModal-module__pJtYKW__form",
  "input": "SignInModal-module__pJtYKW__input",
  "modal": "SignInModal-module__pJtYKW__modal",
  "overlay": "SignInModal-module__pJtYKW__overlay",
  "separator": "SignInModal-module__pJtYKW__separator",
  "title": "SignInModal-module__pJtYKW__title",
  "walletButton": "SignInModal-module__pJtYKW__walletButton",
  "walletButtonContainer": "SignInModal-module__pJtYKW__walletButtonContainer",
});
